<template>
  <div class="py-4 bg-secondary">
    <div class="profile-page">
      <section class="section-new">
        <div class="container">
          <el-row>
            <el-col :span="24">
              <div class="card card-lift shadow border-0 card-address_page mb-3">
                <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                  <el-breadcrumb-item :to="{ path: '/' }">{{ $t('menu.main') }}</el-breadcrumb-item>
                  <el-breadcrumb-item>{{ $t('menu.pro_normative') }}</el-breadcrumb-item>
                </el-breadcrumb>
              </div>
            </el-col>
          </el-row>
        </div>
      </section>




      <section class="section py-3">
        <div class="container">
          <div style="display:flex; align-items: center; gap: 10px; margin-bottom: 10px">
            <el-tabs v-model="activeName" @tab-click="handleClick" style="width: 100%;">
              <el-tab-pane v-for="item in openCardTabs"  :name="item.id.toString()">
                <template slot="label">
                  {{ $i18n.locale === 'uz-UZ' ? item.titleUz : $i18n.locale === 'en-US' ? item.titleUz : $i18n.locale === 'ru-RU' ? item.titleRu : item.titleUzCyr }}
                </template>
                <div class="tab_div_top" v-if="categoryId !== '9'">
                  <card shadow class="card_radius_no" no-body style="z-index: 10;">
                    <div class="px-4">
                      <div class="mt-3 py-3">
                        <a v-for="(item, index) in openResource" :href="item.documentLink" target="_blank"
                           class="card_hujjat_link">
                          <span class="hujjat_title"><strong>{{index + 1}}) </strong>{{ $i18n.locale === 'uz-UZ' ? item.titleUz : $i18n.locale === 'en-US' ? item.titleUz : $i18n.locale === 'ru-RU' ? item.titleRu : item.titleUzCyr }}</span>
                        </a>
                      </div>
                    </div>
                  </card>
                </div>
                <div class="tab_div_top" v-else>
                  <el-row :gutter="15">
                    <el-col :sm="24" :md="12" :lg="8" class="mb-2 mb-lg-10" v-for="item in openResource">
                      <div class="card card-lift shadow border-1 card_xalqaro">
                        <div style="color: #002060;">
                          <img src="img/strategy/x_paper.svg" class="image_xalqaro">
                          <div class="vertical-center" style="margin-left: 85px;">
                            <span class="card_span_xalqaro">{{ $i18n.locale === 'uz-UZ' ? item.textUz : $i18n.locale === 'en-US' ? item.titleUz : $i18n.locale === 'ru-RU' ? item.textRu : item.textUzCyr}}</span>
                            <br>
                            <strong>{{ item.decisionNumber }}</strong>
                          </div>
                        </div>
                        <div class="pdf_link">
                          <a :href="'https://www.prokuratura.uz/api/download/' + item.fileTitle + (item.fileTypeSelected === 'word' ? '.docx' : item.fileTypeSelected === 'excel' ? '.xlsx' : '.pdf') "
                             :download="'https://www.prokuratura.uz/api/download/' + item.fileTitle + (item.fileTypeSelected === 'word' ? '.docx' : item.fileTypeSelected === 'excel' ? '.xlsx' : '.pdf') " target="_blank"
                          >
                            <i class="el-icon-download"></i>
                            PDF
                          </a>
                        </div>
                      </div>
                    </el-col>

                  </el-row>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </section>
      <div style="text-align: center" v-if="openResource.length !== 0">
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="totalPage"
            layout="total, prev, pager, next"
            :total="total">
        </el-pagination>
      </div>    </div>
  </div>
</template>
<script>
import moment from "moment";
import axios from "axios";

export default {
  data() {
    return {
      activeName: '14',
      openCardTabs: [],
      openResource: [],
      categoryId: '14',
      page: 0,
      totalPage: 1,
      currentPage: 1,
      total: 0,
      firstItem: 0
    }
  },

  methods: {
    handleSizeChange(val) {

    },
    handleCurrentChange(val) {
      this.page = val - 1
      this.getOpenData()
    },
    handleClick(tab) {
      this.openResource = []
      this.categoryId = tab.name
      this.getOpenData()
    },
    getOpenData() {
      axios
          .get(`https://www.prokuratura.uz/api/open-data-for-web/?categoryId=${this.categoryId}&page=${this.page}`)
          .then(response => {
            if (response.data.totalElements > 0) {
              this.openResource = response.data.content
              this.total = response.data.totalElements
              this.totalPage = response.data.size
            }
          })

      axios.get(`https://www.prokuratura.uz/api/category-for-open-card-documents`)
          .then(response => {
            this.openCardTabs = response.data
          })

      axios
          .get(`https://www.prokuratura.uz/api/documents-links-for-web-page?categoryId=${this.categoryId}&page=${this.page}`)
          .then(response => {
            if (response.data.totalElements > 0) {
              this.openResource = response.data.content
              this.total = response.data.totalElements
              this.totalPage = response.data.size
            }

          })
    }
  },
  mounted() {
    this.getOpenData()

  }

};
</script>
<style scoped>

.tab_div_top {
  min-height: 600px;
  margin-top: 15px;
}

.pdf_link {
  display: block;
  text-align: right;
  margin-top: -7px;
}
</style>

